import { pmoInstance, getHeader } from "config";

export const findOneTrack = (id) =>
  pmoInstance.get(`/tracks/${id}`, getHeader());

export const findAllTracks = (query = {}) =>
  pmoInstance.get(`/tracks?${new URLSearchParams(query)}`, getHeader());

export const createATrack = (body) =>
  pmoInstance.post("/tracks", body, getHeader());

export const updateATrack = (id, body) =>
  pmoInstance.patch(`/tracks/${id}`, body, getHeader());

export const destroyATrack = (id) =>
  pmoInstance.delete(`/tracks/${id}`, getHeader());

export const findMyTracks = (query = {}) =>
  pmoInstance.get(`/tracks/my`, getHeader());
